// AIPanel.jsx
import React from "react";
import "./AIPanel.scss";

import { PanelControl, IconControl } from "spark-core-dx/components";
import { AISplitPane } from "./AISplitPane"; // adjust path as needed

const AIPanel = ({
  open,
  className,
  children,                  // goes to LEFT "Manual"
  title,
  onCancel,
  width,
  onUpdatePanel,
  onAnimationEnd,
  mapToClass,
  shareLink,
  breakoutLink,
  session,
  referenceId,
  referenceName,
  params,
  operationName,
  sideBarClassName = "side-navbar",
  minPanelWidth = 360,
  minLeft = 360,
  minRight = 360,
  minMiddle = 360,
  enableContentDragHiding = true,
  chatPane = "right",        // 'right' | 'middle' | 'left'
  splashMessage = null,
  introMessage = null,
  startChat = null,
  payload = null,
  // optional pane content
  left,
  middle,
  right
}) => {
  const handleShare = (link) => {
    navigator.clipboard.writeText(link);
    // header toasts live inside AISplitPane; if you want a top-level toast here, we can lift state.
  };
  const handleBreakout = (link) => window.open(link, "_blank");
  const handleOnExit = async () => {
    if (onCancel) await onCancel();
  };

  return (
    <PanelControl
      open={open}
      onClose={handleOnExit}
      onAnimationEnd={onAnimationEnd}
      title={title}
      rootClassName="ai-panel"
      className={className ?? ""}
      mapToClass={mapToClass}
      position="right"
      minWidth={minPanelWidth}
      width={width}
      resizable={true}
      storageKey="ai-panel:width"
      sideBarClassName={sideBarClassName}
      contentClassName="ai-panel-content-scope"
      resizeOverlay = {enableContentDragHiding}
      headerActions={
        <>
          {shareLink && <IconControl iconKey={"share"} title={"Share"} onClick={() => handleShare(shareLink)} />}
          {breakoutLink && (
            <IconControl iconKey={"opennewwindow"} title={"Open in new window"} onClick={() => handleBreakout(breakoutLink)} />
          )}
        </>
      }
    >
      <AISplitPane
        className={className}
        onUpdatePanel={onUpdatePanel}
        session = {session}
        referenceId={referenceId}
        referenceName={referenceName}
        params={params}
        operationName={operationName}
        enableContentDragHiding={enableContentDragHiding}
        chatPane={chatPane}
        payload={payload}
        left={left}
        middle={middle}
        right={right}
        minLeft = {minLeft}
        minMiddle = {minMiddle}
        minRight = {minRight}
        splashMessage = {splashMessage}
        introMessage = {introMessage}
        startChat = {startChat}
      >
        {children}
      </AISplitPane>
    </PanelControl>
  );
};

export default AIPanel;
